import { createAction, props } from "@ngrx/store";
import { IEntrada, IEntradas } from "../../interfaces/entradas";

export const cargarEntradas = createAction(
  "[AcuerdoMrbListComponent] cargar entradas"
);

export const cargarEntradasSuccess = createAction(
  "[AcuerdoMrbListComponent] cargar Entradas Success",
  props<{ entradas: IEntrada[] }>()
);

export const cargarEntradasFail = createAction(
  "[AcuerdoMrbListComponent] cargar entradas fail"
);
